import * as React from 'react'

import { useBonusAccountsWidget } from './hooks'
import { BonusAccount } from './types'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CNav,
  CNavItem,
  CNavLink,
  CSmartTable,
  CTabContent,
  CTabPane,
} from '@coreui/react-pro'
import { useState } from 'react'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import { path } from '../../../../libs'
import { ErrorScreen } from '../../../../shared/components/errorScreen/errorScreen'
import { accountsMounted, setAccountsRequestError } from './model'

export const BonusAccountsWidget = () => {
  const { accounts, errorAccountsRequest } = useBonusAccountsWidget()

  if (![0, 404].includes(errorAccountsRequest.code)) {
    return (
      <ErrorScreen
        showRetry
        onRetry={() => {
          accountsMounted()
          setAccountsRequestError({
            message: '',
            code: 0,
          })
        }}
      />
    )
  }

  return (
    <CCard>
      <CCardHeader>
        <strong>Bonus 111</strong>
      </CCardHeader>
      <CCardBody>
        <BonusAccountsList items={accounts} />
      </CCardBody>
    </CCard>
  )
}

type BonusAccountsListProps = {
  items: BonusAccount[] | undefined
}

const BonusAccountsList = ({ items }: BonusAccountsListProps) => {
  const [activeKey, setActiveKey] = useState(1)

  return (
    <>
      <CNav variant="tabs" role="tablist">
        <CNavItem>
          <CNavLink
            data-tab="activeBonus"
            href="#!"
            active={activeKey === 1}
            onClick={() => setActiveKey(1)}
          >
            Active bonus account
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink
            data-tab="closedDemo"
            href="#!"
            active={activeKey === 2}
            onClick={() => setActiveKey(2)}
          >
            Closed bonus account
          </CNavLink>
        </CNavItem>
      </CNav>
      <CTabContent>
        <CTabPane
          data-tab="activeBonus"
          role="tabpanel"
          aria-labelledby="contact-tab"
          visible={activeKey === 1}
        >
          <BonusAccountsTable items={items}></BonusAccountsTable>
        </CTabPane>
        <CTabPane
          data-tab="closedDemo"
          role="tabpanel"
          aria-labelledby="contact-tab"
          visible={activeKey === 2}
        >
          <BonusAccountsTable items={items}></BonusAccountsTable>
        </CTabPane>
      </CTabContent>
    </>
  )
}

const BonusAccountsTable = ({ items }: BonusAccountsListProps) => {
  const columns = [
    { key: 'login', label: 'MT Login' },
    { key: 'clientId' },
    { key: 'accountOpenedAt' },
    { key: 'accountClosingAt' },
    { key: 'balance' },
    {
      key: 'actions',
      label: 'Actions',
      _style: { width: '10%' },
      filter: false,
      sorter: false,
    },
  ]

  return (
    <CSmartTable
      sorterValue={{ column: 'accountId', state: 'desc' }}
      clickableRows
      tableProps={{
        striped: true,
        hover: true,
      }}
      activePage={3}
      footer
      items={items}
      columns={columns}
      columnFilter
      tableFilter
      cleaner
      itemsPerPageSelect
      itemsPerPage={20}
      columnSorter
      pagination
      scopedColumns={{
        actions: (item: BonusAccount) => {
          return (
            <td className="py-2">
              <CButton
                color="secondary"
                className="me-2"
                title={'Edit'}
                href={path.clients.bonus111Detail(
                  item.clientId,
                  item.accountId,
                )}
              >
                <CIcon icon={cilPencil} />
              </CButton>
            </td>
          )
        },
      }}
    />
  )
}
